import * as sentry from "./sentry"
import configClient from "../../api/hooks/config-client"

export const apiBaseURL = "/api/"

export const sentryDSN = "https://00a4e43c9c8ffb41792a0873433491e8@sentry.basehosts.de/6"
export const sentryTracingOrigins = [
    "localhost",
    "wohner.code.testversion.online/",
    "app.wohner-wechmar.de",
    /^\//,
    /app.wohner-wechmar.de/,
    /wohner-wechmar.de/,
]
export const sentryEnvironment: string = "main"
export const release = configClient.release
console.log("Release: ", release)

// need to execute early for fetch wrapping
sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment, release)
export const maptilerKey = "JSi7YNSWOjnTFcuMCQBW"
